import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Cookies from "js-cookie";
import { COOKIE_AUTH_TOKEN } from "../constants/common";
import { Flex, Spin } from "antd";
import { useHasPermission } from "../hooks/useHasPermission";
interface ProtectedRouteProps {
  children: ReactNode;
  permissions?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  permissions,
}) => {
  const { user, loading } = useAuth();
  const token = Cookies.get(COOKIE_AUTH_TOKEN);
  const location = useLocation();
  const hasPermission = useHasPermission(permissions);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (loading) {
    return (
      <Flex gap="middle" vertical style={{ padding: "2rem" }}>
        <Spin size="large" />
      </Flex>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasPermission) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
